import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logoJRS from '../assets/logo_jrs.png';
import { login } from '../services/api';

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800;900&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  @keyframes spin  { to { transform: rotate(360deg); } }
  @keyframes errIn { from { opacity:0; transform:translateY(-6px); } to { opacity:1; transform:translateY(0); } }
  @keyframes cardIn { from { opacity:0; transform:scale(0.97) translateY(18px); } to { opacity:1; transform:scale(1) translateY(0); } }
  @keyframes f1 { 0%,100%{ transform:translateY(0) rotate(0deg); } 50%{ transform:translateY(-16px) rotate(5deg); } }
  @keyframes f2 { 0%,100%{ transform:translateY(0); } 50%{ transform:translateY(-12px); } }
  @keyframes f3 { 0%,100%{ transform:translateY(0) rotate(45deg); } 50%{ transform:translateY(-14px) rotate(52deg); } }
  @keyframes f4 { 0%,100%{ transform:scale(1); } 50%{ transform:scale(1.06); } }
  @keyframes f5 { 0%,100%{ transform:translateY(0) rotate(0deg); } 50%{ transform:translateY(-10px) rotate(-5deg); } }

  .lg-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: #dde6f5;
    padding: 32px 20px;
  }

  .lg-card {
    display: flex;
    width: 100%;
    max-width: 980px;
    min-height: 600px;
    border-radius: 28px;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(15,23,42,0.04), 0 20px 48px rgba(15,23,42,0.14), 0 48px 96px rgba(15,23,42,0.08);
    animation: cardIn 0.5s cubic-bezier(0.16,1,0.3,1) both;
  }

  /* ════ PAINEL ESQUERDO (colorido) ════ */
  .lg-left {
    width: 48%;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background: #1d4ed8;
  }
  .lg-left::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(150deg, #1e40af 0%, #2563eb 55%, #1d4ed8 100%);
  }
  /* overlay escuro no rodapé para legibilidade */
  .lg-left::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 55%;
    background: linear-gradient(to top, rgba(15,23,42,0.55) 0%, transparent 100%);
    pointer-events: none;
    z-index: 1;
  }

  /* formas */
  .s { position: absolute; pointer-events: none; }

  /* círculo ciano grande — topo esquerdo */
  .s-c1 {
    width: 260px; height: 260px;
    border-radius: 50%;
    background: #06b6d4;
    top: -70px; left: -70px;
    animation: f4 9s ease-in-out infinite;
  }
  /* triângulo laranja grande — topo direito */
  .s-t1 {
    top: -20px; right: -10px;
    width: 0; height: 0;
    border-left: 180px solid transparent;
    border-bottom: 180px solid #f97316;
    animation: f1 7s ease-in-out infinite;
  }
  /* losango laranja — centro */
  .s-d1 {
    width: 80px; height: 80px;
    background: #f97316;
    top: 42%; left: 40%;
    transform: rotate(45deg);
    animation: f3 8s ease-in-out infinite;
  }
  /* losango ciano pequeno — topo centro */
  .s-d2 {
    width: 44px; height: 44px;
    background: #22d3ee;
    top: 16%; right: 26%;
    transform: rotate(45deg);
    animation: f3 5s 1s ease-in-out infinite;
  }
  /* triângulo ciano — meio esquerda */
  .s-t2 {
    bottom: 40%; left: 10%;
    width: 0; height: 0;
    border-left: 34px solid transparent;
    border-right: 34px solid transparent;
    border-bottom: 58px solid #22d3ee;
    opacity: 0.9;
    animation: f5 10s ease-in-out infinite;
  }
  /* triângulo laranja invertido — meio direita */
  .s-t3 {
    top: 55%; right: 12%;
    width: 0; height: 0;
    border-left: 26px solid transparent;
    border-right: 26px solid transparent;
    border-top: 44px solid #fb923c;
    animation: f1 6s 2s ease-in-out infinite;
  }
  /* círculo azul escuro — centro esquerda */
  .s-c2 {
    width: 58px; height: 58px;
    border-radius: 50%;
    background: #1e3a8a;
    top: 44%; left: 7%;
    animation: f2 11s ease-in-out infinite;
  }
  /* círculo laranja — direita baixo */
  .s-c3 {
    width: 110px; height: 110px;
    border-radius: 50%;
    background: #f97316;
    bottom: 22%; right: -22px;
    animation: f4 8s 1s ease-in-out infinite;
  }
  /* retângulo azul escuro — centro */
  .s-r1 {
    width: 110px; height: 76px;
    background: #1e3a8a;
    border-radius: 12px;
    opacity: 0.65;
    top: 30%; left: 24%;
    animation: f2 13s ease-in-out infinite;
  }
  /* grade de pontos */
  .s-dots {
    top: 12%; right: 7%;
    display: grid;
    grid-template-columns: repeat(4, 9px);
    gap: 8px;
    animation: f5 12s ease-in-out infinite;
  }
  .s-dot {
    width: 7px; height: 7px;
    border-radius: 50%;
    background: #fb923c;
  }

  .lg-left-text {
    position: relative;
    z-index: 2;
    padding: 0 40px 44px;
  }
  .lg-left-title {
    font-size: 1.35rem;
    font-weight: 800;
    color: #fff;
    line-height: 1.3;
    margin-bottom: 10px;
    letter-spacing: -0.3px;
  }
  .lg-left-sub {
    font-size: 0.82rem;
    color: rgba(255,255,255,0.65);
    line-height: 1.65;
    margin-bottom: 20px;
    max-width: 280px;
  }
  .lg-pips { display: flex; gap: 6px; }
  .lg-pip {
    height: 6px; border-radius: 3px;
    background: rgba(255,255,255,0.35);
    transition: all 0.3s;
  }
  .lg-pip.on { width: 22px; background: #fff; }
  .lg-pip:not(.on) { width: 6px; }

  /* ════ PAINEL DIREITO (formulário) ════ */
  .lg-right {
    flex: 1;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding: 44px 52px;
  }

  .lg-logo {
    margin-bottom: auto;
    display: flex;
    justify-content: center;
  }
  .lg-logo img { height: 52px; object-fit: contain; display: block; }

  .lg-form-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 36px 0 24px;
  }

  .lg-form-title {
    font-size: 1.5rem;
    font-weight: 800;
    color: #0f172a;
    text-align: center;
    letter-spacing: -0.4px;
    margin-bottom: 6px;
  }
  .lg-form-sub {
    font-size: 0.8rem;
    color: #94a3b8;
    text-align: center;
    margin-bottom: 32px;
  }

  /* campos */
  .lg-field { margin-bottom: 16px; }
  .lg-label {
    display: block;
    font-size: 0.74rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 6px;
  }
  .lg-iw { position: relative; }
  .lg-input {
    width: 100%;
    padding: 12px 14px;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
    font-size: 0.9rem;
    font-family: 'Plus Jakarta Sans', sans-serif;
    color: #0f172a;
    background: #f8fafc;
    outline: none;
    transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
    caret-color: #2563eb;
  }
  .lg-input::placeholder { color: #cbd5e1; }
  .lg-input:focus {
    border-color: #2563eb;
    background: #fff;
    box-shadow: 0 0 0 4px rgba(37,99,235,0.09);
  }
  .lg-input-pwd { padding-right: 42px; }
  .lg-eye {
    position: absolute;
    right: 12px; top: 50%;
    transform: translateY(-50%);
    background: none; border: none;
    color: #cbd5e1; cursor: pointer;
    font-size: 0.9rem; padding: 4px;
    transition: color 0.15s;
  }
  .lg-eye:hover { color: #64748b; }

  /* botão */
  .lg-btn {
    width: 100%;
    padding: 9px 16px;
    background: #0f172a;
    color: #fff;
    border: none;
    border-radius: 6px;
    font-size: 0.78rem;
    font-weight: 600;
    font-family: 'Plus Jakarta Sans', sans-serif;
    letter-spacing: 0.01em;
    cursor: pointer;
    margin-top: 8px;
    transition: background 0.18s, transform 0.12s, box-shadow 0.18s;
    box-shadow: 0 2px 8px rgba(15,23,42,0.18);
    display: flex; align-items: center; justify-content: center; gap: 6px;
  }
  .lg-btn:hover:not(:disabled) {
    background: #1e293b;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(15,23,42,0.24);
  }
  .lg-btn:active:not(:disabled) { transform: translateY(0); }
  .lg-btn:disabled { opacity: 0.5; cursor: not-allowed; }

  /* erro */
  .lg-err {
    background: #fff5f5;
    border: 1.5px solid #fecaca;
    border-radius: 9px;
    padding: 10px 13px;
    margin-bottom: 16px;
    display: flex; align-items: center; gap: 8px;
    color: #dc2626;
    font-size: 0.8rem; font-weight: 600;
    animation: errIn 0.2s ease;
  }

  .lg-spinner {
    width: 14px; height: 14px;
    border: 2px solid rgba(255,255,255,0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.65s linear infinite;
    display: inline-block; flex-shrink: 0;
  }

  .lg-divider {
    display: flex; align-items: center; gap: 10px;
    margin: 20px 0 0;
  }
  .lg-divider-line { flex: 1; height: 1px; background: #e2e8f0; }
  .lg-divider-txt {
    font-size: 0.72rem;
    font-weight: 600;
    color: #64748b;
    white-space: nowrap;
    letter-spacing: 0.01em;
  }

  .lg-footnote {
    margin-top: auto;
    text-align: center;
    font-size: 0.72rem;
    font-weight: 500;
    color: #94a3b8;
    padding-top: 8px;
    letter-spacing: 0.01em;
  }

  @media (max-width: 700px) {
    .lg-left { display: none; }
    .lg-right { padding: 36px 28px; }
  }
`;

export default function Login({ onLogin }) {
  const [form, setForm]       = useState({ username: '', password: '' });
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erro, setErro]       = useState('');
  const navigate              = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.username || !form.password) { setErro('Preencha usuário e senha.'); return; }
    setLoading(true); setErro('');
    try {
      const { data } = await login(form.username, form.password);
      localStorage.setItem('access_token', data.access);
      localStorage.setItem('refresh_token', data.refresh);
      onLogin({ username: form.username });
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setErro(err.response?.status === 401 ? 'Usuário ou senha incorretos.' : 'Erro ao conectar ao servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{css}</style>
      <div className="lg-page">
        <div className="lg-card">

          {/* ── ESQUERDA colorida ── */}
          <div className="lg-left">
            {/* formas */}
            <div className="s s-c1" />
            <div className="s s-t1" />
            <div className="s s-d1" />
            <div className="s s-d2" />
            <div className="s s-t2" />
            <div className="s s-t3" />
            <div className="s s-c2" />
            <div className="s s-c3" />
            <div className="s s-r1" />
            <div className="s s-dots">
              {Array.from({ length: 16 }).map((_, i) => <div className="s-dot" key={i} />)}
            </div>

            <div className="lg-left-text">
              <div className="lg-left-title">JRS — Sistema interno<br />de controle de ponto</div>
              <div className="lg-left-sub">Gerencie jornadas, compensações e banco de horas dos colaboradores com agilidade e precisão.</div>
              <div className="lg-pips">
                <div className="lg-pip on" />
                <div className="lg-pip" />
                <div className="lg-pip" />
              </div>
            </div>
          </div>

          {/* ── DIREITA formulário ── */}
          <div className="lg-right">
            <div className="lg-logo">
              <img src={logoJRS} alt="JRS" />
            </div>

            <div className="lg-form-body">
              <div className="lg-form-title">Acesso ao sistema</div>
              <div className="lg-form-sub">Entre com suas credenciais para continuar</div>

              <form onSubmit={handleSubmit} autoComplete="on">
                {erro && (
                  <div className="lg-err">
                    <i className="bi bi-exclamation-circle-fill" style={{ flexShrink: 0 }} />
                    {erro}
                  </div>
                )}

                <div className="lg-field">
                  <label className="lg-label">Usuário</label>
                  <div className="lg-iw">
                    <input
                      className="lg-input"
                      type="text"
                      autoComplete="username"
                      value={form.username}
                      onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
                      placeholder="Nome de usuário"
                    />
                  </div>
                </div>

                <div className="lg-field">
                  <label className="lg-label">Senha</label>
                  <div className="lg-iw">
                    <input
                      className="lg-input lg-input-pwd"
                      type={showPwd ? 'text' : 'password'}
                      autoComplete="current-password"
                      value={form.password}
                      onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                      placeholder="••••••••"
                    />
                    <button type="button" className="lg-eye" onClick={() => setShowPwd(v => !v)}>
                      <i className={`bi ${showPwd ? 'bi-eye-slash' : 'bi-eye'}`} />
                    </button>
                  </div>
                </div>

                <button type="submit" className="lg-btn" disabled={loading}>
                  {loading
                    ? <><span className="lg-spinner" /> Verificando...</>
                    : 'Entrar'
                  }
                </button>
              </form>

              <div className="lg-divider">
                <div className="lg-divider-line" />
                <div className="lg-divider-txt">
                  <i className="bi bi-shield-check" style={{ marginRight: 4 }} />
                  Acesso restrito a colaboradores
                </div>
                <div className="lg-divider-line" />
              </div>
            </div>

            <div className="lg-footnote">
              JRS Serviços Empresariais · CNPJ 24.028.923/0001-10
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
